import { store } from "../components/App/store";

export function getAuthHeader() {
  const user = store.getState()?.user;
  return {
    headers: { Authorization: `Bearer ${user?.token}` },
  };
}
